import type { FC } from 'react';

import { MobileCategory } from './MobileCategory/MobileCategory';
import type { InpageNavProps } from '~/types/props';

export const MobileCategoryRenderer: FC<InpageNavProps> = ({ inpageNavigation }) =>
  inpageNavigation ? <MobileCategory inpageNavigation={inpageNavigation} /> : null;
